import React from 'react'
import styled from 'styled-components'

import stonks from '../../res/landing/items/stonks.svg'
import wifi from '../../res/landing/items/wifi.svg'
import protect from '../../res/landing/items/protect.svg'
import bell from '../../res/landing/items/bell.svg'

function Benefits() {
  return (
    <Container>
        <h2>Beneficios</h2>
        <Items>
            <li className="item">
                <img src={stonks} alt="logo"/>
                <h1>Monitoreo en tiempo real</h1>
                <h3>
                    Visualizá en tiempo real el consumo energético de tus medidores, incluso aquellos ubicados a gran distancia.
                </h3>
            </li>
            <li className="item">
                <img src={wifi} alt="logo"/>
                <h1>Conexión segura</h1>
                <h3>
                    Nuestras redes cuentan con encriptación avanzada para proteger los datos.
                </h3>
            </li>
            <li className="item">
                <img src={protect} alt="logo"/>
                <h1>Optimización de consumo</h1>
                <h3>
                    El análisis inteligente de datos permite detectar oportunidades de optimización y aplicar tarifas dinámicas o segmentadas por bandas horarias.
                </h3>
            </li>
            <li className="item">
                <img src={bell} alt="logo"/>
                <h1>Alertas Inteligentes</h1>
                <h3>
                    Detectá en tiempo real anomalías, fallas técnicas y posibles intentos de fraude.
                </h3>
            </li>
        </Items>
    </Container>
  )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100;
    height: auto;
    align-items: center;
    gap: 2vh;
    h2{
        font-family: 'montserrat', sans-serif;
        font-size: 32px;
        font-style: 'semi-bold';
        font-weight: 400;
        color: #2858A2;
    }
`

const Items = styled.ul`
    width: 80%;
    list-style-type: none;
    display: grid;
    grid-template-columns: repeat(
        auto-fit,
        minmax(240px, 1fr)
    );
    gap: 20px;
    padding: 0;
    
    .item{
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 3.2fr 6fr;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        padding-top: 1vh;
        width: 100%;
        height: 42vh;
        border: 1px solid #f1f5f9;
        border-radius: 8px;
        background-color: #fff;
        
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1)  
    }

    .item:hover{
        border-color: rgba(37, 99, 235, 0.3);
        box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1);
    }

    .item img{
        position: relative;
        top: 5%;
        left: 5%;
        height: auto;
        width: 7%;
    }

    .item h1{
        position: relative;
        top: 2%;
        font-family: 'montserrat', sans-serif;
        font-style: semi-bold;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 100%;
        text-align: left;
        color: black;
        margin-left: 5%;
        margin-right: 5%;
        
    }

    .item h3{
        position: relative;
        top: 2%;
        font-family: 'montserrat', sans-serif;
        font-style: regular;
        font-size: 1.2;
        font-weight: 1;
        line-height: 1.5rem;
        color: rgba(0, 0, 0, .7);
        width: 90%;
        margin-left: 5%;
    }
`

export default Benefits